import { hydrateRoot } from 'react-dom/client';
import { RelayEnvironmentProvider } from 'react-relay';
import serverVars from 'server-vars';

import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';

import { getRelayEnvironment } from '../utils/relayModernEnvironment.ts';
import { NftExhibitionsWrapper } from './NftExhibitionsWrapper.tsx';
import { trackPageview } from 'dibs-tracking';

const environment = getRelayEnvironment({
    ...serverVars.get('dbl.relayData'),
});

initializeDBL().then(({ store }: { store: $TSFixMe }) => {
    hydrateRoot(
        document.getElementById('js-root') as HTMLElement,
        <RelayEnvironmentProvider environment={environment}>
            <NftExhibitionsWrapper
                locale={serverVars.get('intlVariables.locale')}
                store={store}
                deviceType={serverVars.get('deviceType')}
            />
        </RelayEnvironmentProvider>
    );
    trackPageview({
        additional: {
            pageType: 'Other',
            pageSubType: `NFT Marketplace`,
        },
    });
});
